<template>

    <div class="p-4 bg-gris-bleu rounded-lg shadow mb-4">

        <p class="text-md text-primary" v-if="ot">
            Référence : <span class="font-bold text-secondary">{{ ot }}</span>
        </p>
        <p class="text-md text-primary">
            Intervention n° : <span class="font-bold text-secondary">{{ code }}</span>
        </p>
        <h2 class="text-md mt-1">
            Détenteur : <span class="font-bold text-secondary">{{ detenteur.raison_sociale }} {{ detenteur.ville
                }}</span>
        </h2>
        <p class="text-md mt-1">
            Installation : <span class="font-bold text-secondary">{{ installation.nom }}
                {{ (installation.marque) ? ' - ' + installation.marque : '' }}
                {{ (installation.modele) ? ' - ' + installation.modele : '' }}</span>
        </p>
        <div class="flex items-center gap-3 mt-3" v-if="gotFluide">
            <div v-if="gotFluide"
                class="flex items-center gap-1 px-3 py-1 rounded-r-full bg-secondary text-white text-sm font-medium -ml-4">
                <i class="inline-block h-5 w-5 mask mask-snow bg-white"></i>
                <span>{{ installation.fluide.nom }}</span>
            </div>
            <div v-if="gotFluide" class="flex items-center gap-1">
                <i class="inline-block h-5 w-5 mask mask-weight bg-secondary"></i>
                <span class="text-md font-medium text-black"><strong>{{ installation.charge }}</strong> kg</span>
            </div>
            <div v-if="gotFluide && isFibsdd" class="flex items-center gap-1">
                <i class="inline-block h-8 w-8 mask mask-co2 bg-secondary"></i>
                <span class="text-md font-medium text-black">{{ installation.tonnage }}</span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {}
    },
    props: {
        code: '',
        ot: '',
        detenteur: {},
        installation: {},
        gotFluide: null,
        isFibsdd: null
    },
    computed: {},
    methods: {},
    components: {}
}

</script>


// WEBPACK FOOTER //
// SmallRecap.vue?2ffef006